import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M12 21a9 9 0 100-18 9 9 0 000 18zm-1.58-3.89l6.215-5.966a.2.2 0 00-.14-.344l-4.519.052a.2.2 0 01-.184-.283l1.654-3.64c.09-.2-.16-.378-.32-.227l-5.76 5.447a.2.2 0 00.137.346h4.641a.2.2 0 01.176.295l-2.215 4.08c-.11.2.15.397.314.24z",
      "clip-rule": "evenodd"
    })
  ]))
}